// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_container {
  width: 100vw;
  height: 100vh;
  background: linear-gradient(120deg, rgb(39, 6, 45) 30%, rgb(60, 30, 95) 60%, rgb(9, 23, 51) 100%);
  display: flex;
}
.login_container .left_side {
  width: 60%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 10rem;
}
.login_container .left_side .welcome_text {
  color: #FFFFFF;
}
.login_container .left_side .subtext {
  width: 50%;
  color: #FFFFFF;
  font-size: 0.8rem;
  margin-top: 0.5rem;
}
.login_container .right_side {
  width: 40%;
  height: 100vh;
  display: flex;
  align-items: center;
}
.login_container .right_side .login_section {
  width: 80%;
  background-color: #FFFFFF;
  padding: 1.6rem 0;
  border-radius: 0.8rem;
  font-size: 80%;
}
.login_container .right_side .login_section h2 {
  padding: 0 0 1.6rem 1.5rem;
  font-size: 1.8rem;
}
.login_container .right_side .login_section .login_form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 1.2rem;
}
.login_container .right_side .login_section .login_form input {
  padding: 0.8rem;
  font-size: 1rem;
  outline: none;
  border: 1px solid #DCDCDC;
  border-radius: 0.8rem;
  color: #747373;
}
.login_container .right_side .login_section .login_form input::placeholder {
  color: #c0bfbf;
}
.login_container .right_side .login_section .login_form .password_block {
  width: 100%;
  position: relative;
}
.login_container .right_side .login_section .login_form .password_block input {
  width: 100%;
}
.login_container .right_side .login_section .login_form .password_block .hide_password {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 1.5rem;
  font-size: 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #775DA6;
}
.login_container .right_side .login_section .login_form .password_block .hide_password:hover {
  color: #9474d0;
}
.login_container .right_side .login_section .login_form p {
  color: #775DA6;
  text-decoration: none;
  cursor: pointer;
}
.login_container .right_side .login_section .login_form p:hover {
  text-decoration: underline;
}
.login_container .right_side .login_section .login_form #login_btn {
  padding: 0.8rem 0;
  border-radius: 0.3rem;
  outline: none;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);
  font-size: 1rem;
  color: #FFFFFF;
  cursor: pointer;
  position: relative;
}
.login_container .right_side .login_section .login_form #login_btn:hover {
  background: linear-gradient(180deg, #e51f75 0%, #a31452 100%);
}
.login_container .right_side .login_section .login_form #login_btn .login_spin {
  position: absolute;
  left: 2rem;
  top: 20%;
  transform: translateY(-20%);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 2rem;
  animation: detecting 1s linear infinite;
}

@keyframes detecting {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/login/_Login.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EAKA,iGAAA;EAMA,aAAA;AARJ;AAUI;EACI,UAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AARR;AAUQ;EACI,cAAA;AARZ;AAWQ;EACI,UAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;AATZ;AAaI;EACI,UAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;AAXR;AAaQ;EACI,UAAA;EACA,yBAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;AAXZ;AAaY;EACI,0BAAA;EACA,iBAAA;AAXhB;AAcY;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,iBAAA;AAZhB;AAcgB;EACI,eAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;AAZpB;AAcoB;EACI,cAAA;AAZxB;AAgBgB;EACI,WAAA;EACA,kBAAA;AAdpB;AAgBoB;EACI,WAAA;AAdxB;AAiBoB;EACI,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,iBAAA;EACA,aAAA;EAAc,uBAAA;EACd,mBAAA;EACA,eAAA;EACA,cAAA;AAdxB;AAgBwB;EACI,cAAA;AAd5B;AAmBgB;EACI,cAAA;EACA,qBAAA;EACA,eAAA;AAjBpB;AAmBoB;EACI,0BAAA;AAjBxB;AAmCgB;EACI,iBAAA;EACA,qBAAA;EACA,aAAA;EACA,2CAAA;EACA,6DAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAjCpB;AAmCoB;EACI,6DAAA;AAjCxB;AAoCoB;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,uCAAA;AAlCxB;;AA2CA;EACI;IACI,uBAAA;EAxCN;EA2CE;IACI,yBAAA;EAzCN;AACF","sourcesContent":[".login_container {\n    width: 100vw;\n    height: 100vh;\n    // background-color: #2b272e;\n    // background-image: url('../../assets/old background.png');\n    // background-repeat: no-repeat;\n    // background-size: cover;\n    background: linear-gradient(\n        120deg, \n        rgba(39, 6, 45, 1) 30%, \n        rgba(60, 30, 95, 1) 60%, \n        rgba(9, 23, 51, 1) 100%\n      );\n    display: flex;\n\n    .left_side {\n        width: 60%;\n        height: 100vh;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        padding-left: 10rem;\n\n        .welcome_text {\n            color: #FFFFFF;\n        }\n\n        .subtext {\n            width: 50%;\n            color: #FFFFFF;\n            font-size: .8rem;\n            margin-top: .5rem;\n        }\n    }\n\n    .right_side {\n        width: 40%;\n        height: 100vh;\n        display: flex;\n        align-items: center;\n\n        .login_section {\n            width: 80%;\n            background-color: #FFFFFF;\n            padding: 1.6rem 0;\n            border-radius: .8rem;\n            font-size: 80%;\n\n            h2 {\n                padding: 0 0 1.6rem 1.5rem;\n                font-size: 1.8rem;\n            }\n\n            .login_form {\n                display: flex;\n                flex-direction: column;\n                gap: 1rem;\n                padding: 0 1.2rem;\n\n                input {\n                    padding: .8rem;\n                    font-size: 1rem;\n                    outline: none;\n                    border: 1px solid #DCDCDC;\n                    border-radius: .8rem;\n                    color: #747373;\n\n                    &::placeholder {\n                        color: #c0bfbf;\n                    }\n                }\n\n                .password_block{\n                    width: 100%;\n                    position: relative;\n\n                    input{\n                        width: 100%;\n                    }\n\n                    .hide_password{\n                        position: absolute;\n                        top: 50%;\n                        transform: translateY(-50%);\n                        right: 1.5rem;\n                        font-size: 1.5rem;\n                        display: flex;justify-content: center;\n                        align-items: center;\n                        cursor: pointer;\n                        color: #775DA6;\n\n                        &:hover {\n                            color: #9474d0;\n                        }\n                    }\n                }\n\n                p {\n                    color: #775DA6;\n                    text-decoration: none;\n                    cursor: pointer;\n\n                    &:hover{\n                        text-decoration: underline;\n                    }\n                }\n\n                // button {\n                //     padding: .8rem 0;\n                //     border-radius: .3rem;\n                //     outline: none;\n                //     border: 1px solid rgba(255, 255, 255, 0.15);\n                //     background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);\n                //     font-size: 1rem;\n                //     color: #FFFFFF;\n                //     cursor: pointer;\n\n                //     &:hover {\n                //         background: linear-gradient(180deg, #e51f75 0%, #a31452 100%);\n                //     }\n                // }\n                #login_btn {\n                    padding: .8rem 0;\n                    border-radius: .3rem;\n                    outline: none;\n                    border: 1px solid rgba(255, 255, 255, 0.15);\n                    background: linear-gradient(180deg, #D91D6F 0%, #92124A 100%);\n                    font-size: 1rem;\n                    color: #FFFFFF;\n                    cursor: pointer;\n                    position: relative;\n\n                    &:hover {\n                        background: linear-gradient(180deg, #e51f75 0%, #a31452 100%);\n                    }\n\n                    .login_spin{\n                        position: absolute;\n                        left: 2rem;\n                        top: 20%;\n                        transform: translateY(-20%);\n                        display: flex;\n                        justify-content: center;\n                        align-items: center;\n                        font-size: 2rem;\n                        animation: detecting 1s linear infinite;\n                        // border: 1px solid black;\n                    }\n                }\n            }\n        }\n    }\n}\n\n@keyframes detecting {\n    from {\n        transform: rotate(0deg);\n    }\n\n    to {\n        transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
